import { Component } from 'react';
import CommonDialog from '../../shared/dialog/CommonDialog';
import css from '../account-settings.module.scss';
import ChangePasswordForm from './ChangePasswordForm';
import ChangePasswordSuccess from './ChangePasswordSuccess';
import GeneralSettingsForm from './GeneralSettingsForm';
import GeneralSettingsSuccess from './GeneralSettingsSuccess';

export default class GeneralSettings extends Component {
  state = {
    generalSettingsSuccessDialogOpen: false,
    changePasswordFormDialogOpen: false,
    changePasswordSuccessDialogOpen: false,
  };

  openGeneralSettingsSuccessDialog = () => {
    this.setState({ generalSettingsSuccessDialogOpen: true });
  };

  closeGeneralSettingsSuccessDialog = () => {
    this.setState({ generalSettingsSuccessDialogOpen: false });
  };

  openChangePasswordFormDialog = () => {
    this.setState({ changePasswordFormDialogOpen: true });
  };

  closeChangePasswordFormDialog = () => {
    this.setState({ changePasswordFormDialogOpen: false });
  };

  openChangePasswordSuccessDialog = () => {
    this.setState({ changePasswordSuccessDialogOpen: true });
  };

  closeChangePasswordSuccessDialog = () => {
    this.setState({ changePasswordSuccessDialogOpen: false });
  };

  handleSuccessfulPasswordChange = () => {
    this.closeChangePasswordFormDialog();
    this.openChangePasswordSuccessDialog();
  };

  render() {
    const {
      generalSettingsSuccessDialogOpen,
      changePasswordFormDialogOpen,
      changePasswordSuccessDialogOpen,
    } = this.state;

    return (
      <div>
        <GeneralSettingsForm
          handleChangePasswordClick={this.openChangePasswordFormDialog}
          onSubmitSuccess={this.openGeneralSettingsSuccessDialog}
        />
        <CommonDialog
          data-testid="generalSettingsSuccessDialog"
          key="generalSettingsSuccessDialog"
          dialogOpen={generalSettingsSuccessDialogOpen}
          handleDialogClose={this.closeGeneralSettingsSuccessDialog}
          classNames={{
            body: css.dialogBody,
            content: css.dialogContent,
          }}
          closeButtonProps={{ className: css.closeIcon }}
        >
          <GeneralSettingsSuccess />
        </CommonDialog>
        <CommonDialog
          data-testid="confirmPasswordFormDialog"
          key="confirmPasswordFormDialog"
          dialogOpen={changePasswordFormDialogOpen}
          handleDialogClose={this.closeChangePasswordFormDialog}
          classNames={{
            body: css.dialogBody,
            content: css.dialogContent,
          }}
          closeButtonProps={{ className: css.closeIcon }}
        >
          <ChangePasswordForm
            handleSuccessfulPasswordChange={this.handleSuccessfulPasswordChange}
          />
        </CommonDialog>
        <CommonDialog
          data-testid="confirmPasswordSuccessDialog"
          key="confirmPasswordSuccessDialog"
          dialogOpen={changePasswordSuccessDialogOpen}
          handleDialogClose={this.closeChangePasswordSuccessDialog}
          classNames={{
            body: css.dialogBody,
            content: css.dialogContent,
          }}
          closeButtonProps={{ className: css.closeIcon }}
        >
          <ChangePasswordSuccess />
        </CommonDialog>
      </div>
    );
  }
}
